import { render, staticRenderFns } from "./FaqFilters.vue?vue&type=template&id=e23e156a"
import script from "./FaqFilters.vue?vue&type=script&lang=js"
export * from "./FaqFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports